import errorMappingService from '@/services/error-mapping-service';
import store from '@/store';

export class GlobalValidationErrorHandler {

  constructor(errors) {
    this.errors = errors;
  }

  setMappedErrors(formFields, id, errors = this.errors) {
    const { mappedErrors, errorsForValidator } = errorMappingService.extractErrors(errors, formFields, id);
    this.mappedErrors = mappedErrors;
    this.errorsForValidator = errorsForValidator;
    return this;
  }

  execute(formFields, observer, id, cacheCallbackSetter, withErrorNotification = true) {
    this.setMappedErrors(formFields, id)
      .setErrorsIntoObserver(observer)
      .invokeCacheErrors(cacheCallbackSetter);

    if (withErrorNotification) {
      this.showErrorNotification();
    }
  }

  setErrorsIntoObserver(observer, errors = this.errorsForValidator) {
    if (observer != undefined) {
      observer.setErrors(errors);
    }
    return this;
  }

  invokeCacheErrors(cacheCallbackSetter, mappedErrors = this.mappedErrors, errorsForValidator = this.errorsForValidator) {
    if (cacheCallbackSetter != undefined) {
      cacheCallbackSetter({ mappedErrors, errorsForValidator });
    }
    return this;
  }

  showErrorNotification(mappedErrors = this.mappedErrors) {
    store.dispatch('errorNotificationStore/setErrors', mappedErrors);
    store.dispatch('errorNotificationStore/showErrorNotification');
    return this;
  }
}
